<template >
  <div class="new-home-packs">
    <div class="pack-box trial-offer align-center" >
      <p class="discover text-uppercase opCookies-style">
          Ontdek je pakket

        <span class="arrow-down"></span>
      </p>
      <h3>Dit geschenk is een onderdeel <br> van je
          proefperiode van <br> <span class="purple-text"> € 2 / 2 maanden </span> </h3>
      <p class="text-uppercase purple-text">Jij ontvangt</p>
      <ul>
        <li>Jouw magazines in zowel papieren als digitale versie</li>
        <li>Onbeperkte juridische advies, fiscale en technische hulp</li>
        <li>12 praktische gidsen per jaar</li>
        <li>Een door jou gekozen welkomstgeschenk</li>
          <b-button v-if="isMobile" class="button is-primary next-button opcookies-button" @click="nextStep()">
              Vraag je pakket aan
          </b-button>
      </ul>
    </div>
      <GiftChoiceList v-if="box === 'list'" ></GiftChoiceList>
      <GiftChoiceTableau v-if="box === 'tableau'" ></GiftChoiceTableau>
      <GiftChoiceTableauSchool v-if="box === 'school'" ></GiftChoiceTableauSchool>
      <GiftChoiceDynamic v-if="box === 'dynamic'" ></GiftChoiceDynamic>
      <GiftChoiceTableauAndroid v-if="box === 'android'" ></GiftChoiceTableauAndroid>
      <GiftChoiceTableauLenovo v-if="box === 'tableau_lenovo_coque'" ></GiftChoiceTableauLenovo>
<!--      <GiftChoiceArchos v-if="box === 'tableau-archos'" ></GiftChoiceArchos>-->
      <GiftChoiceCooking v-if="box === 'cooking'" ></GiftChoiceCooking>
      <GiftChoiceCooking2024 v-if="box === 'cooking2024'" ></GiftChoiceCooking2024>
  </div>
</template>
<script>
import mixin from "../../../components/form/steps/travel_step_mixin";
import GiftChoiceTableau from "../../_commons/nl/newComponents/GiftChoiceTableau.vue";
import GiftChoiceTableauSchool from "../../_commons/nl/newComponents/GiftChoiceTableauSchool";
import GiftChoiceDynamic from "./GiftChoiceDynamic";
import GiftChoiceTableauAndroid from "../../_commons/nl/newComponents/GiftChoiceTableauAndroid";
import GiftChoiceList from "../../_commons/nl/newComponents/GiftChoiceList";
import GiftChoiceCooking from "../../_commons/nl/newComponents/GiftChoiceCooking";
import GiftChoiceCooking2024 from "../../_commons/nl/newComponents/GiftChoiceCooking2024";
import GiftChoiceTableauLenovo from "../../_commons/nl/newComponents/GiftChoiceTableauLenovo";
export default {
    mixins: [mixin],
    components: {GiftChoiceList, GiftChoiceCooking2024, GiftChoiceTableau, GiftChoiceTableauSchool, GiftChoiceDynamic, GiftChoiceTableauAndroid, GiftChoiceCooking,GiftChoiceTableauLenovo},
    props: {
        box: {
            type: String,
            default: 'list'
        },
    },
    computed: {
        isMobile() {
            return window.innerWidth <= 768;
        }
    }
};
</script>
